import React from 'react';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import { Link, } from 'react-router-dom';
import ProductsUpload from '../../Models/ProductsUpload';
import Products from '../../Models/Products';
import { CategoriesShowProducts } from './CategoriesShowProducts';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import 'rc-menu/assets/index.css';
class Categories extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsCountPerPage: 5,
            pageRangeDisplayed: 3,
            categories: [],
            allCategories: [],
            categoryProducts: [],
            allProducts: [],
            total: []
        };
        this.getTotal();
        this.getAllCategories();
        this.getCategory();
        this.getAllProducts();
        console.log(this.props.match.params.id)
        // console.log("!!!!!!!!!!!!!!! ", this.props.history.location.state);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        console.log('first')
    }
    getCategory() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    handleClick(id) {
        this.props.history.push(`/sub-categories/${id}`);
    }
    getAllProducts() {
        if (localStorage.getItem('aff-id') !== null || localStorage.getItem('aff-id') !== '') {
            Products.getAffiliatorProductsListTemp().then(res => {
                if (res.data.payload != null) {
                    this.setState({ allProducts: res.data.payload })
                }
            })
        } else {
            Products.getProductsListTemp().then(res => {
                this.setState({ allProducts: res.data.payload })
            })
        }
    }

    getAllCategories() {
        Products.getProductsList(this.props.match.params.id, 1).then(res => {
            this.setState({ allCategories: res.data.cat_name })
        })
    }
    getTotal() {
        Products.getProductsList(this.props.match.params.id, 1).then(res => {
            this.setState({ total: res.data })
        })
    }

    handlePageChange(pageNumber) {
        Products.getProductsList(this.props.match.params.id, pageNumber).then(res => {
            this.setState({ allProducts: res.data.payload })
            this.setState({ activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage });
        })
    }

    render() {
        // const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="container">
                        <Header />
                    </div>
                    <div className="container-fluid">
                        <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                        <div className="col-md-12 tr_blank_medium mt-5 "> </div>
                        <div className="row">
                            <div className="col-md-3 remember_text"></div>
                            <div className="col-md-9 large_fonts">
                                <CategoriesShowProducts id={this.props.match.params.id} />
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <div className="container">
                        <Header />
                    </div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                            <div className="col-md-12 tr_blank_medium mt-5"> </div>
                            <div className="col-md-12">
                                <div className="row">
                                    {/* <div className="col-md-1"></div> */}
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-12 large_fonts">
                                                <CategoriesShowProducts id={this.props.match.params.id} category_name={this.props.history.location.state.name}  />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-1"></div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
    }
}
export { Categories }
